import Seo from "../components/Seo";
import BookingForm from "../components/forms/BookingForm";
import FareLockup from "../components/FareLockup";
import DisclaimerBand from "../components/DisclaimerBand";

export default function BookJourney() {
  return (
    <main data-testid="book-page" className="mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-16">
      <Seo
        title="Book a Journey — Request Your £100 Fixed Fare Black Cab"
        description="Request a £100 fixed-fare journey between Essex and London. Pay your driver cash or card inside the cab. No advance payment. Subject to driver availability."
      />
      <div className="max-w-2xl">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#D4AF37]">
          Book a journey
        </p>
        <h1 className="mt-3 text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
          Request your £100 journey
        </h1>
        <p className="mt-4 leading-relaxed text-[#A1A1AA]">
          Complete the form below and we will check availability with our Essex-based London
          Black Cab drivers. This is a booking request — we will contact you to confirm before
          any journey is arranged.
        </p>
      </div>

      <div className="mt-12 grid gap-10 lg:grid-cols-[1fr_380px]">
        <div className="border border-[#27272A] bg-[#0B0B0B] p-6 sm:p-10">
          <BookingForm />
        </div>
        <aside className="space-y-6 lg:sticky lg:top-24 lg:self-start">
          <FareLockup />
          <DisclaimerBand />
        </aside>
      </div>
    </main>
  );
}
